export const updateObject = (oldObject, updatedProperties) => ({
	...oldObject,
	...updatedProperties,
});

export const getChangesCount = (changesObj) => {
	let count = 0;
	Object.keys(changesObj).forEach((key) => {
		if (typeof changesObj[key] === 'object') {
			count += Object.keys(changesObj[key]).length;
		} else count++;
	});
	return count;
};
